<template>
  <div class="w-100 pt-2 d-flex px-3 justify-content-around align-items-center">
    <ImageToggle
      data-testid="card-status-toggle"
      v-if="showToggle"
      :value="disableCard"
      :defaultIcon="'lock_open_right'"
      :toggleIcon="'lock'"
      :defaultTitle="t('PAYJOY_CARD_VIEWS.CC_DETAILS_DISABLE_TITLE')"
      :toggleTitle="t('PAYJOY_CARD_VIEWS.CC_DETAILS_ENABLE_TITLE')"
      @input="handleToggleCard"
    />
    <ImageToggle
      data-testid="details-visibility-toggle"
      v-if="showToggle"
      :value="showDetails"
      :disable="disableCard"
      :defaultIcon="'visibility_off'"
      :toggleIcon="'visibility'"
      :defaultTitle="t('PAYJOY_CARD_VIEWS.CC_DETAILS_ACTIVE_SHOW_TITLE')"
      :toggleTitle="t('PAYJOY_CARD_VIEWS.CC_DETAILS_ACTIVE_HIDE_TITLE')"
      @input="(val) => $emit('toggleDetails', val)"
    />
    <ImageToggle
      data-testid="delete-card-button"
      v-if="showDelete"
      :defaultIcon="'delete_forever'"
      :toggleIcon="'delete_forever'"
      :defaultTitle="t('PAYJOY_CARD_VIEWS.CC_DETAILS_DELETE_VIRTUAL_CARD')"
      :toggleTitle="t('PAYJOY_CARD_VIEWS.CC_DETAILS_DELETE_VIRTUAL_CARD')"
      @click="$emit('deleteCard')"
    />
    <ImageToggle
      class="mx-auto"
      data-testid="create-card-button"
      v-if="showCreate"
      :disable="disableCreate"
      :defaultIcon="'add_card'"
      :toggleIcon="'add_card'"
      :defaultTitle="t('PAYJOY_CARD_VIEWS.CC_DETAILS_CREATE_VIRTUAL_CARD')"
      :toggleTitle="t('PAYJOY_CARD_VIEWS.CC_DETAILS_CREATE_VIRTUAL_CARD')"
      @click="$emit('createCard')"
    />
  </div>

  <hr class="mb-1 mt-0 p-0" />

  <span v-if="showWalletBtn">
    <div class="w-100 pt-2 pb-2 px-3 text-center" v-if="walletBtnType == 'add'">
      <img
        @click="$emit('addToWallet')"
        :src="useAsset(addToWalletAsset)"
        alt="Add to Google Wallet"
        class="walletBtn"
      />
    </div>

    <div
      class="col fill-txt d-flex justify-content-between align-items-center hm-2p5"
      v-if="walletBtnType == 'added'"
    >
      <h6 class="mt-2 mb-2 d-flex align-items-center">
        <span
          class="material-symbols-outlined me-2 green"
          style="line-height: 1; vertical-align: middle"
        >
          credit_score
        </span>
        {{ t("PAYJOY_CARD_VIEWS.CC_DETAILS_ADDED_TO_WALLET") }}
      </h6>
    </div>

    <hr class="mb-1 mt-1 p-0" v-if="walletBtnType !== 'none'"
  /></span>

  <div
    data-testid="calculator-tool-container"
    class="w-100 py-2 d-flex px-0 justify-content-between align-items-center"
    @click="() => $emit('navToCardIntro')"
  >
    <div
      class="col fill-txt d-flex justify-content-between align-items-center hm-2p5"
    >
      <h6 class="mt-1 mb-2 d-flex align-items-center">
        <span
          class="material-symbols-outlined me-3"
          style="line-height: 1; vertical-align: middle"
        >
          credit_card_heart
        </span>
        {{ t("PAYJOY_CARD_VIEWS.CC_DETAILS_HOW_TO_USE_VIRTUAL") }}
      </h6>
      <div>
        <i class="fa fa-chevron-right"></i>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import ImageToggle from "@/apps/credit-line/components/ImageToggle.vue";
import { useConfirmationModal } from "@/shared-hooks/useConfirmationModal";
import useAsset from "@/apps/credit-line/helpers/useAsset";
const { confirm } = useConfirmationModal();

const { t } = useI18n();

interface Props {
  showToggle: boolean;
  showDelete: boolean;
  showCreate: boolean;
  disableCard: boolean;
  showDetails: boolean;
  disableCreate: boolean;
  walletBtnType: "none" | "add" | "added";
  addToWalletAsset: string;
  showWalletBtn: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  (e: "toggleCard", value: "ACTIVE" | "BLOCKED"): void;
  (e: "toggleDetails", value: boolean): void;
  (e: "deleteCard"): void;
  (e: "createCard"): void;
  (e: "navToCalculator"): void;
  (e: "navToCardIntro"): void;
  (e: "addToWallet"): void;
}>();

const handleToggleCard = async (disable: boolean) => {
  if (
    disable &&
    !(await confirm({
      title: t("CONFIRMTOGGLECARDOFF"),
      message: "",
      confirmText: t("YES"),
      cancelText: t("CANCEL"),
    }))
  ) {
    return;
  }

  return emit("toggleCard", !disable ? "ACTIVE" : "BLOCKED");
};
</script>

<style>
.hm-2p5 {
  margin-left: 2.5%;
  margin-right: 2.5%;
}

.walletBtn {
  width: 60%;
}
</style>
